<template>
  <a-card :bordered='false'>
    <a-button type="primary" v-has:dealerCreate="()=> {$router.push('/antiFleeingGoods/documents/allocationAdd')}">
      <PlusOutlined />
      创建调拨单
    </a-button>
    <a-form class="m-b-20 m-t-20" ref='form' :model='search'  :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="" name='keyword'>
        <a-input-group compact :style="{width:'360px'}">
          <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
            <a-select-option value="order_no">出库单号</a-select-option>
            <a-select-option value="user_id">收货人名称</a-select-option>
            <a-select-option value="phone">创建人</a-select-option>
          </a-select>
          <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
        </a-input-group>
      </a-form-item>
      <a-form-item label="创建时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="changTime" />
      </a-form-item>
      <a-form-item label="调拨单状态" name='allocation_status'>
        <a-select v-model:value="search.allocation_status" :style="{width:'160px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="1">待接受</a-select-option>
          <a-select-option :value="2">经销商接受调拨</a-select-option>
          <a-select-option :value="3">订单关闭</a-select-option>
          <a-select-option :value="4">经销商申请关闭订单</a-select-option>
          <a-select-option :value="5">已出货</a-select-option>
          <a-select-option :value="6">已签收</a-select-option>
          <a-select-option :value="7">总部拒绝关闭订单</a-select-option>
          <a-select-option :value="8">拒绝关闭继续发货</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='allocation_sn' :columns='columns' :data-source='data' >
      <template v-slot:action="{ record }">
        <a-dropdown>
          <a class="ant-dropdown-link"> 操作
            <DownOutlined />
          </a>
          <template v-slot:overlay>
            <a-menu>
              <a-menu-item>
                <a @click="()=> {$router.push('/antiFleeingGoods/documents/allocationDetails?id='+record.allocation_sn)}"
                  href="javascript:;">详情</a>
              </a-menu-item>
              <a-menu-item v-if='record.allocation_status == 1'>
                <a href="javascript:;" @click='close(record.allocation_sn)' >关闭订单</a>
              </a-menu-item>
              <a-menu-item v-if='record.allocation_status == 4'>
                <a href="javascript:;" @click='visible = true;itemId = record.allocation_sn' >处理订单</a>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
  </a-card>
  <a-modal :keyboard="false" title="处理订单" centered v-model:visible="visible" :confirm-loading="confirmLoading" destroyOnClose @ok='handle'>
    <a-form-item label="是否同意关闭订单">
      <a-radio-group v-model:value="apply">
        <a-radio :value="1">同意</a-radio>
        <a-radio :value="0">拒绝</a-radio>
      </a-radio-group>
    </a-form-item>
    <a-form-item label="拒绝原因" v-if='apply == 0'>
      <a-textarea v-model:value="reason" placeholder="请填写拒绝原因，限100字内" :rows="4" :maxlength='100' style="width: 350px;" />
    </a-form-item>
  </a-modal>
</template>
<script>
  import { PlusOutlined, DownOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message,Modal } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { iscode } from "@/utils/app";
  import { getAllocation, closeAllocation, handelAllocation } from "@/api/antiFleeing";
  // 初始化默认筛选项数值
  let defSearch = {
    start_time: "",
    end_time: "",
    allocation_status:'',
    page: 1,
    limit: 10,
    key_type: "order_no",
    keyword: "",
  };
  export default {
    components: { PlusOutlined, DownOutlined },
    setup() {
      // // 初始化 分页信息和筛选项信息
      const search = ref({ ...defSearch });
      // 列表数据和列头配置
      const data = ref([]);
      const state = reactive({
        listLoading: false,
        time: [],
        total: 0,
        itemId:'',//查看出货二维码商品id
        visible:false, //是否显示处理订单
        confirmLoading:false, //处理订单loading状态
        apply:1, //处理订单是否同意
        reason:'', //处理订单拒绝理由
      });
      let columns = [
        {
          title: "调拨单号",
          dataIndex: "allocation_sn",
          key: "allocation_sn",
        },

        {
          title: "调出经销商",
          dataIndex: "from",
          key: "from",
        },
        {
          title: "调入经销商",
          dataIndex: "to",
          key: "to",
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          key: "create_time",
        },
        {
          title: "创建人",
          dataIndex: "create_role_name",
          key: "create_role_name",
        },
        {
          title: "调拨单状态",
          dataIndex: "allocation_status_text",
          key: "allocation_status_text",
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject("$router");
      const $Modal = inject("$Modal");

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const changTime = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      // 关闭
      const close = (id) => {
        Modal.confirm({
          centered: true,
          title:'确定关闭订单？',
          content: '订单关闭后将无法开启',
          onOk: async () => {
            let res = await closeAllocation(id).then((res) => res.data);
            if (iscode(res, true)) {
              initData();
            }
          },
        });
      };
      // 处理订单
      const handle = async () => {
        if(state.apply == 0 && state.reason == ''){
          message.error('请填写拒绝理由！');
          return
        }
        let res = await handelAllocation({sn:state.itemId,apply:state.apply,reason:state.reason}).then((res) => res.data);
        if (iscode(res, true)) {
          initData();
        }
      };
      const initData = async () => {
        state.listLoading = true;
        try {
          let res = await getAllocation({...search.value}).then((res) => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data;
            state.total = res.meta.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        initData();
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        changTime,
        close,
        handle
      };
    },
  };
</script>